var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var {
  View,
  StyleSheet,
} = ReactNative;

var Animated = {}
var animIndex = 0;
Animated.Value = function(value, identifier)
{
  var me = this;
  me.animIndex = animIndex++;
  me.value = value;
  if( typeof identifier !== 'undefined' )
  {
    me.identifier = identifier;
  }

  me.setValue = function(newValue)
  {
    me.value = newValue;
    if( typeof me.listeners === 'undefined' ) me.listeners = [];
    for( var i = 0; i < me.listeners.length; i++ )
    {
      me.listeners[i]({value:me.getValue()});
    }
  };

  me.getValue = function()
  {
    return me.value;
  };

  me.listeners = [];
  me.addListener = function(listener)
  {
    if( typeof me.listeners === 'undefined' ) me.listeners = [];
    for( var i = 0; i < me.listeners.length; i++ )
    {
      if( me.listeners[i] === listener ) return; // already registered
    }

    me.listeners.push(listener);
  }

  me.removeListener = function(listener)
  {
    var newListeners = [];
    for( var i = 0; i < me.listeners.length; i++ )
    {
      if( me.listeners[i] !== listener ) newListeners.push(me.listeners[i]);
    }

    me.listeners = newListeners;
  }

  return me;
}

var DELTA_T = 10;
Animated.timing = function(value, params)
{
  // var value = value;
  var startValue = value.getValue();
  var toValue = params.toValue;
  var deltaValue = toValue - startValue;
  var duration = params.duration;
  value.callback = null;
  value.duration = duration;
  if( duration === 0 )
  {
    value.setValue(toValue);
    return;
  }

  value.timeout = null;
  var timeoutFunction = function()
  {
    var newTime = new Date().getTime();
    var t = Math.min(value.duration, newTime - value.startTime);
    var newValue = startValue + parseFloat(deltaValue*parseFloat(t/value.duration));
    // console.log("time val", t, duration, newValue)
    value.setValue(newValue);
    if( t < duration )
    {
      value.timeout = setTimeout(timeoutFunction, DELTA_T);
    }
    else
    {
      if( value.callback != null ) value.callback();
      value.callback = null;

      if( value.timeout != null ) clearTimeout(value.timeout);
      value.timeout = null;

      value.stop = null;
    }
  }

  var stop = function()
  {
    if( value.callback != null ) value.callback();
    value.callback = null;

    if( value.timeout != null ) clearTimeout(value.timeout);
    value.timeout = null;
  }
  value.stop = stop;

  var start = function(newCallback)
  {
    if( value.stop ) value.stop();
    value.startTime = new Date().getTime();
    value.stop = value.newStop;
    if( value.timeout != null ) clearTimeout(value.timeout);
    value.timeout = null;
    if( typeof newCallback !== 'undefined' ) value.callback = newCallback;
    timeoutFunction();

    return value;
  }
  value.start = start;
  value.newStop = stop;

  return value;
}

Animated.spring = function(value, params)
{
  // var value = value;
  var startValue = value.getValue();
  var toValue = params.toValue;
  return Animated.timing(value, {toValue, duration:300})
}

function separateStyle(style)
{
  var staticStyle = {};
  var animatedStyle = {};
  var flatStyle = StyleSheet.flatten(style);
  for( var key in flatStyle )
  {
    var thisStyle = flatStyle[key];
    if( key == 'transform' )
    {
      var hasAnim = false;
      for( var i = 0; i < thisStyle.length; i++ )
      {
        var thisTransform = thisStyle[i];
        for( var transKey in thisTransform )
        {
          if( typeof thisTransform[transKey].getValue !== 'undefined' )
          {
            hasAnim = true;
            break;
          }
        }
        if( hasAnim ) break;
      }
      if( hasAnim ) animatedStyle.transform = thisStyle;
      else staticStyle.transform = thisStyle;
    }
    else if( typeof thisStyle !== 'undefined' )
    {
      if( typeof thisStyle.getValue !== 'undefined' ) animatedStyle[key] = thisStyle;
      else staticStyle[key] = thisStyle;
    }
  }

  return {staticStyle, animatedStyle};
}

Animated.View = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      style: {}
    }
  },

  getInitialState : function()
  {
    var style = this.props.style;
    var {staticStyle, animatedStyle} = separateStyle(style);

    return {
      staticStyle, animatedStyle
    }
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.style !== 'undefined' )
    {
      var {staticStyle, animatedStyle} = separateStyle(newProps.style);
      this.registerAnimatedStyles(animatedStyle);
      this.setState({staticStyle, animatedStyle});
    }
  },

  componentDidMount : function()
  {
    this.registerAnimatedStyles(this.state.animatedStyle);
  },

  componentWillUnmount : function()
  {
    this.unRegisterAnimatedStyles(this.state.animatedStyle);
  },

  registerAnimatedStyles : function(animatedStyle)
  {
    for( var key in animatedStyle )
    {
      if( key == 'transform' )
      {
        for( var i = 0; i < animatedStyle.transform.length; i++ )
        {
          for( var transKey in animatedStyle.transform[i] )
          {
            if( typeof animatedStyle[key][i][transKey].getValue !== 'undefined' ) animatedStyle.transform[i][transKey].addListener(this.animatedValueUpdated);
          }
        }
      }
      else animatedStyle[key].addListener(this.animatedValueUpdated);
    }
  },

  unRegisterAnimatedStyles : function(animatedStyle)
  {
    for( var key in animatedStyle )
    {
      if( key == 'transform' )
      {
        for( var i = 0; i < animatedStyle.transform.length; i++ )
        {
          for( var transKey in animatedStyle.transform[i] )
          {
            if( typeof animatedStyle[key][i][transKey].getValue !== 'undefined' ) animatedStyle.transform[i][transKey].removeListener(this.animatedValueUpdated);
          }
        }
      }
      else animatedStyle[key].removeListener(this.animatedValueUpdated);
    }
  },

  animatedValueUpdated : function(info)
  {
    this.forceUpdate();
  },

  render: function()
  {
    var {style, ...otherProps} = this.props;
    var {staticStyle, animatedStyle, ...otherState} = this.state;

    var actualStyle = {};
    for( var key in staticStyle ) actualStyle[key] = staticStyle[key];
    for( var key in animatedStyle )
    {
      if( key == 'transform' )
      {
        var actualTransform = [];
        for( var i = 0; i < animatedStyle.transform.length; i++ )
        {
          var actualTranformItem = {}
          for( var transKey in animatedStyle.transform[i] )
          {
            if( typeof animatedStyle.transform[i][transKey].getValue !== 'undefined' )
            {
              actualTranformItem[transKey] = animatedStyle.transform[i][transKey].getValue();
              if( transKey == "rotate" || transKey == "rotateY" ) actualTranformItem[transKey] += "deg";
            }
            else actualTranformItem[transKey] = animatedStyle.transform[i][transKey];
          }
          actualTransform.push(actualTranformItem);
        }
        actualStyle.transform = actualTransform;
      }
      else actualStyle[key] = animatedStyle[key].getValue();
    }
// console.log("actualStyle", actualStyle)
    return <View {...otherProps} style={actualStyle}/>
  }
});

module.exports = Animated;
